<template>
  <TopGradientBlockLayout>
    <div class="text-xl font-bold text-text leading-tight mb-11">{{ $t('title') }}</div>
    <div class="space-y-12">
      <div class="grid lg:grid-cols-2 items-center col-gap-12 row-gap-6">
        <BaseSelect
            v-model="font_selected"
            :options="fonts_list"
            :select-label="$t('fontLabel')"
            label="title"
            :allow-empty="false"
            :searchable="false"
            :show-labels="false"/>
        <div class="text-xs text-text-ternary">{{ $t('fontTip') }}</div>
      </div>
      <div class="grid lg:grid-cols-2 items-center col-gap-12 row-gap-6">
        <BaseSelect
            v-model="theme_selected"
            :options="theme_list"
            :select-label="$t('themeLabel')"
            label="title"
            :allow-empty="false"
            :searchable="false"
            :show-labels="false"/>
        <div class="text-xs text-text-ternary">{{ $t('themeTip') }}</div>
      </div>
      <div class="grid lg:grid-cols-2 items-center col-gap-12 row-gap-6">
        <BaseCheckbox :checked="show_help"
                      @change="show_help = $event">
          {{ $t('displayHelperLabel') }}
        </BaseCheckbox>
      </div>
      <BaseButton theme="gray"
                  class="w-91"
                  :loading="saving"
                  @click="saveSettings">
        {{ $t('save') }}
      </BaseButton>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseButton from "@/components/UI/BaseButton";
import BaseCheckbox from "@/components/UI/BaseCheckbox";

export default {
  name: "TheTheming",
  components: {
    BaseCheckbox,
    BaseButton,
    BaseSelect,
    TopGradientBlockLayout,
  },
  computed: {
    ...mapState('cabinet/user', ['user_info'])
  },
  data() {
    return {
      saving: false,
      font_selected: {title: this.$t('font3'), val: 3},
      fonts_list: [
        {title: this.$t('font1'), val: 1},
        {title: this.$t('font2'), val: 2},
        {title: this.$t('font3'), val: 3},
        {title: this.$t('font4'), val: 4},
        {title: this.$t('font5'), val: 5},
      ],
      theme_selected: {val: 1, title: 'Светлая'},
      theme_list: [
        {val: 1, title: this.$t('themeLight')},
        {val: 2, title: this.$t('themeDark')}
      ],
      show_help: true
    }
  },
  methods: {
    ...mapActions('cabinet/user', ['updateUserSettings']),
    ...mapMutations('cabinet/user', ['setUserSettings']),
    ...mapMutations('theme', ['setColorTheme', 'setFontTheme']),
    async saveSettings() {
      try {
        this.saving = true;
        let data = {
          id: this.user_info.data.id,
          font_size: !!this.font_selected ? this.font_selected.val : null,
          theme: !!this.theme_selected ? this.theme_selected.val : null,
        };
        const res = await this.updateUserSettings(data);
        if (res.body.success) {
          this.setUserSettings(res.body.data);
          this.setColorTheme(res.body.data.theme);
          this.setFontTheme(res.body.data.font_size);
          this.$toasted.success('Изменения сохранены');
          this.saving = false;
        } else {
          console.log(res);
          this.$toasted.error('Произошла ошибка');
        }
      } catch (err) {
        console.log(err)
        this.$toasted.error('Произошла ошибка');
      } finally {
        this.saving = false;
      }
    },
    setFields() {
      let user = this.user_info.data;
      if (!!user.settings) {
        this.font_selected = this.fonts_list.filter(i => i.val === user.settings.font_size)[0]
        this.theme_selected = this.theme_list.filter(i => i.val === user.settings.theme)[0]
        this.show_help = user.settings.show_help;
      }
    }
  },
  mounted() {
    this.setFields();
  },
  i18n: {
    messages: {
      en: {
        title: 'Theming',
        fontLabel: 'Text size',
        fontTip: 'Choose a font size more convenient for viewing',
        font1: 'Tiny',
        font2: 'Small',
        font3: 'Medium',
        font4: 'Large',
        font5: 'Extra Large',
        themeLabel: 'Theme',
        themeTip: 'Choose your side!',
        themeLight: 'Light',
        themeDark: 'Dark',
        displayHelperLabel: 'Show assistance',
        save: 'Save'
      },
      ru: {
        title: 'Оформление',
        fontLabel: 'Размер текста',
        fontTip: 'Выберите размер шрифта, более удобный для просмотра',
        font1: 'Крошечный',
        font2: 'Маленький',
        font3: 'Средний',
        font4: 'Крупный',
        font5: 'Большой',
        themeLabel: 'Тема оформления',
        themeTip: 'Выбери свою сторону!',
        themeLight: 'Светлая',
        themeDark: 'Тёмная',
        displayHelperLabel: 'Отображать справку на страницах',
        save: 'Сохранить'
      }
    }
  }
}
</script>